const COLLAPSED_CARDS = 2.5;
const PC_MQ = '(min-width: 768px)';

class BrandHistory extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.list = this.querySelector('[data-brand-history-list]');
    this.more = this.querySelector('[data-brand-history-more]');
    this.items = this.list ? [...this.list.querySelectorAll('.brand-history__item')] : [];

    if (!this.list || this.items.length <= 2) {
      this.more?.setAttribute('hidden', '');
      return;
    }

    this.expanded = false;
    this.sync();

    this.more?.addEventListener('click', () => this.expand());
    window.addEventListener('resize', () => this.sync(), { passive: true });
  }

  isPc() {
    return window.matchMedia(PC_MQ).matches;
  }

  gap() {
    const styles = getComputedStyle(this.list);
    return parseFloat(styles.rowGap || styles.gap) || 0;
  }

  collapsedHeight() {
    const gap = this.gap();
    const first = this.items[0]?.offsetHeight || 0;
    const second = this.items[1]?.offsetHeight || 0;
    const third = this.items[2]?.offsetHeight || 0;
    return first + gap + second + gap + third * (COLLAPSED_CARDS - 2);
  }

  sync() {
    if (this.isPc() || this.expanded) {
      this.list.style.maxHeight = '';
      this.classList.toggle('is-expanded', this.expanded || this.isPc());
      if (this.isPc()) this.more?.setAttribute('hidden', '');
      else if (!this.expanded) this.more?.removeAttribute('hidden');
      return;
    }

    this.classList.remove('is-expanded');
    this.more?.removeAttribute('hidden');
    this.list.style.maxHeight = `${this.collapsedHeight()}px`;
  }

  expand() {
    if (this.expanded || this.isPc()) return;

    this.expanded = true;
    this.list.style.maxHeight = `${this.list.scrollHeight}px`;
    this.classList.add('is-expanded');
    this.more?.setAttribute('hidden', '');

    const onEnd = (event) => {
      if (event.propertyName !== 'max-height') return;
      this.list.style.maxHeight = '';
      this.list.removeEventListener('transitionend', onEnd);
    };
    this.list.addEventListener('transitionend', onEnd);
  }
}

if (!customElements.get('brand-history')) {
  customElements.define('brand-history', BrandHistory);
}
